<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" id="side-logo" :collapse="isCollapse" />

    <el-scrollbar>
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="variables.menuBg" :text-color="variables.menuText" :unique-opened="false" :active-text-color="variables.menuActiveText" :collapse-transition="false" mode="vertical">
        <sidebar-item v-for="route in authRoutes" :key="route.path" :item="route" />
      </el-menu>
    </el-scrollbar>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {}
  },

  computed: {
    // FIXME: 暂时使用authRoutes
    ...mapGetters(['sidebar', 'routes', 'authRoutes']),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      this.$store.dispatch({
        type: 'login/setActiveMenu',
        activeMenu: route.meta.title || ''
      })
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },

  created() {
    // init the default selected tab
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
::v-deep .el-scrollbar__wrap {
  height: calc(100% - 30px);
  overflow: auto;
}
</style>
